// components/common/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 50); // slight delay to ensure content is loaded

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
